import { FinanceEmailAttachmentsField } from './FinanceEmailAttachmentsField';
import type { DetailFormCustomFieldRenderer } from './types';

const ATTACHMENTS_FIELD = 'attachmentnames';

export const createFinanceEmailAttachmentsFieldRenderer = (
  historyId: string | undefined
): DetailFormCustomFieldRenderer => {
  return ({ fieldName, metadata, isRequired, hideCaption, captionsWidth }) => {
    if (!historyId || fieldName.toLowerCase() !== ATTACHMENTS_FIELD) {
      return undefined;
    }

    const label = `${metadata.title || metadata.caption || fieldName}${isRequired ? ' *' : ''}`;

    return (
      <FinanceEmailAttachmentsField
        historyId={historyId}
        label={label}
        hideCaption={hideCaption}
        captionsWidth={captionsWidth}
      />
    );
  };
};
